import { Injectable, signal } from '@angular/core';
import { StoredMenuJsonItem, StoredProfileDetails } from './manage-session';

export interface SessionContext {
  menuJson?: StoredMenuJsonItem[] | null;
  isVerified?: boolean | null;
  profileDetails?: StoredProfileDetails | null;
}

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private readonly menuJsonState = signal<StoredMenuJsonItem[] | null>(null);
  private readonly verificationState = signal<boolean | null>(null);
  private readonly profileDetailsState = signal<StoredProfileDetails | null>(null);

  setSessionContext(context: SessionContext | null | undefined): void {
    this.setMenuJson(context?.menuJson ?? null);
    this.setVerificationState(context?.isVerified ?? null);
    this.setProfileDetails(context?.profileDetails ?? null);
  }

  setMenuJson(menuJson: StoredMenuJsonItem[] | null | undefined): void {
    if (!menuJson?.length) {
      this.menuJsonState.set(null);
      return;
    }

    this.menuJsonState.set(menuJson);
  }

  getMenuJson(): StoredMenuJsonItem[] | null {
    return this.menuJsonState();
  }

  clearMenuJson(): void {
    this.menuJsonState.set(null);
  }

  setVerificationState(isVerified: boolean | null | undefined): void {
    this.verificationState.set(typeof isVerified === 'boolean' ? isVerified : null);
  }

  getVerificationState(): boolean | null {
    return this.verificationState();
  }

  clearVerificationState(): void {
    this.verificationState.set(null);
  }

  setProfileDetails(profileDetails: StoredProfileDetails | null | undefined): void {
    this.profileDetailsState.set(profileDetails ?? null);
  }

  getProfileDetails(): StoredProfileDetails | null {
    return this.profileDetailsState();
  }

  getSubstationId(): number | null {
    const substationId = this.profileDetailsState()?.substation_id;
    return typeof substationId === 'number' && Number.isFinite(substationId) ? substationId : null;
  }

  clearProfileDetails(): void {
    this.profileDetailsState.set(null);
  }

  clearSession(): void {
    this.clearMenuJson();
    this.clearVerificationState();
    this.clearProfileDetails();
  }
}
